import { render, staticRenderFns } from "./nbn-order-primary-actions.vue?vue&type=template&id=1ed40002&scoped=true"
import script from "./nbn-order-primary-actions.vue?vue&type=script&lang=js"
export * from "./nbn-order-primary-actions.vue?vue&type=script&lang=js"
import style0 from "./nbn-order-primary-actions.vue?vue&type=style&index=0&id=1ed40002&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed40002",
  null
  
)

export default component.exports